import { Box, Skeleton } from '@mui/material';
import styled from 'styled-components';

const Field = () => (
  <FieldWrap>
    <Skeleton variant="text" width="55%" height={14} />
    <Skeleton variant="text" width="80%" height={22} />
  </FieldWrap>
);

export const DetailFieldsSkeleton = ({ fieldCount = 7 }) => (
  <Container aria-hidden="true">
    {Array.from({ length: fieldCount }).map((_, index) => (
      <Field key={index} />
    ))}
  </Container>
);

const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 10px;
  border-radius: 2px;
  background-color: rgba(248, 244, 249, 0.48);
`;

const FieldWrap = styled.div`
  min-width: 140px;
  flex: 1 1 140px;
`;
